'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { map } from 'rxjs/operators/map';
import SmartContent from '../models/SmartContent';
const generateUrl = contentId => `targeted/v1/definitions/by-content/${contentId}`;
export default {
  fetchSmartContent: contentId => {
    return http.get(generateUrl(contentId)).pipe(map(SmartContent.fromJS));
  }
};